var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-drawer',_vm._g(_vm._b({attrs:{"custom-class":_setup.cusClass,"title":_vm.title,"destroy-on-close":true}},'el-drawer',_vm.$attrs,false),_setup.drawerListeners),[_vm._t("default"),_vm._v(" "),(_vm.$slots.footer)?_c('div',{staticClass:"drawer-footer"},[_vm._t("footer")],2):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }